import * as React from "react";
import type { SVGProps } from "react";
const SvgCogwheel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#cogwheel_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10.31 21.424A2.7 2.7 0 0 0 12 22a2.7 2.7 0 0 0 2.65-2.08.6.6 0 0 1 .08-.21.73.73 0 0 1 1-.24 2.72 2.72 0 0 0 3.74-3.74.6.6 0 0 1-.08-.21.71.71 0 0 1 .53-.87 2.73 2.73 0 0 0 0-5.3.6.6 0 0 1-.21-.08.74.74 0 0 1-.24-1 2.72 2.72 0 0 0-3.74-3.74 1 1 0 0 1-.21.09.72.72 0 0 1-.87-.54 2.73 2.73 0 0 0-5.3 0 .71.71 0 0 1-.756.554.7.7 0 0 1-.324-.104 2.67 2.67 0 0 0-3.34.4 2.67 2.67 0 0 0-.4 3.34.6.6 0 0 1 .08.21.71.71 0 0 1-.53.87 2.73 2.73 0 0 0 0 5.3q.112.02.21.08a.74.74 0 0 1 .24 1 2.67 2.67 0 0 0 .4 3.34 2.67 2.67 0 0 0 3.34.4q.1-.057.21-.09a.72.72 0 0 1 .87.54 2.7 2.7 0 0 0 .96 1.504m.025-3.475a2.74 2.74 0 0 0-1.685-.589 2.8 2.8 0 0 0-.65.08 3.1 3.1 0 0 0-.75.32.72.72 0 0 1-1-1 2.73 2.73 0 0 0-.91-3.75 3 3 0 0 0-.78-.32.72.72 0 0 1 0-1.4 2.74 2.74 0 0 0 2-3.29 3 3 0 0 0-.33-.76.72.72 0 0 1 1-1 2.73 2.73 0 0 0 4.06-1.67.72.72 0 0 1 1.4 0 2.74 2.74 0 0 0 3.29 2 3.1 3.1 0 0 0 .78-.32.72.72 0 0 1 1 1 2.73 2.73 0 0 0 .91 3.75 3 3 0 0 0 .78.29.72.72 0 0 1 0 1.4 2.74 2.74 0 0 0-2 3.29q.105.412.32.78a.72.72 0 0 1-1 1 2.74 2.74 0 0 0-3.75.91q-.215.367-.32.78a.72.72 0 0 1-1.4 0 2.74 2.74 0 0 0-.965-1.501m-.557-2.623a4 4 0 1 0 4.444-6.652 4 4 0 0 0-4.444 6.652m1.11-4.989a2 2 0 1 1 2.223 3.326 2 2 0 0 1-2.222-3.326"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="cogwheel_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCogwheel;
